import { render } from "./rubros.vue?vue&type=template&id=60f7c41d&scoped=true"
import script from "./rubros.vue?vue&type=script&lang=js"
export * from "./rubros.vue?vue&type=script&lang=js"

import "./rubros.vue?vue&type=style&index=0&id=60f7c41d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f7c41d"]])

export default __exports__